import React from 'react';

import { $changeZIndex } from './../../mixin/mixin-jquery';

class SingleDiscipline extends React.Component {
  constructor() {
    super();

    this._handleClick = this._handleClick.bind(this);
    this._$changeZIndex = $changeZIndex;
  }

  render() {
    return <li className="degrees__item">
      <a href="#" className="title"
         onClick={this._handleClick.bind(null, this.props.data.label)}>
        {this.props.data.label}
      </a>
    </li>;
  }

  _handleClick(name, e) {
    e.preventDefault();

    let actions = [
      {type: 'LBOX::OPEN'},
      {type: 'CURR_DISC::UPDATE', value: name},
      {type: 'UNITS_BY_DISC::FETCH', value: name}
    ];

    // open lightbox
    this.props.dispatchReducer(actions);
    // increase container's z-index to override everything
    this._$changeZIndex($('#main-wrapper'), 10000);
    $('html').addClass('no-scroll');
  }
}

SingleDiscipline.propTypes = {
  data:            React.PropTypes.object.isRequired,
  dispatchReducer: React.PropTypes.func.isRequired
};

export default SingleDiscipline;
